import React, { Fragment } from 'react'
import { CircleButton, Label } from '../../../components'
import ChildObject from '../ChildObject'
import DropDown from './dropdown'
import { getKeyOfOpt, lookupOption } from './optionUtils'
import { ReactComponent as CloseIcon } from '../../../images/icons/times-pro.svg'

const HybridList = (props) => {
  const {
    id,
    name,
    label,
    helpText,
    value,
    context,
    rtOptions,
    optionQuery,
    optFields,
    optionKeyName,
    getOptionTextFn,
    topRecordId,
    isInsideModal,
  } = props

  // value is an array of JS objects, but they may be outdated values -- if options are userData (from evaluation)
  // they may have changed. In this case, look up current values using key!
  const newValue = optionQuery
    ? value
    : value && value.reduce((previous, current) => {
      const newOpt = lookupOption(getKeyOfOpt(current, optionKeyName), rtOptions)
      return newOpt ? [...previous, newOpt] : previous
    }, [])
  // if (newValue && !newValue.length) {
  //   newValue = null
  // }

  // Create a temporary ArrayState to facilitate display of selected values
  const listState = context.getSelectionContext(name, newValue /* || -1 */)
  const varDef = context.getVarDef(name) // selection variable definition

  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} idFor={null}/><br/>

      {newValue && newValue.map(
        (itemVal, idx) => {
          const optId = id + '|' + idx
          return (
            <div key={'div' + optId} className={'d-flex'} onKeyUp={ null /* onEnter */ }>
              <ChildObject
                key={optId}
                activate={false}
                name={name}
                label={label}
                helpText={null}
                id={optId}
                index={idx}
                // eslint-disable-next-line
                style={'popup'}
                type={'object'}
                typeName={varDef.typeName}
                value={itemVal}
                context={listState}
                topRecordId={topRecordId}
                getSummaryOverrideFn={getOptionTextFn}
              />
              {listState && listState.mutable && (
                <div onClick={() => listState.deleteObject(idx)}>
                  <CloseIcon className={'m-2 timesBtn'}/>
                </div>
              )}
            </div>
          )},
      )}

      <div className={'d-flex align-items-center'}>
        <CircleButton id={id + '|add'} icon={'icon-plus2'} onClick={() => null}/>
        <div className={'flex-fill'}>
          <DropDown id={id + 'add'}
                    name={name}
                    label={null}
                    helpText={null}
                    searchable={true}
                    isList={false}
                    value={''}
                    context={context}
                    rtOptions={rtOptions}
                    optionQuery={optionQuery}
                    optFields={optFields}
                    onChange={(optVal) => {
                      if (listState && listState.mutable) {
                        listState.addNewObject(optVal)
                      }
                    }}
                    optionKeyName={optionKeyName}
                    getOptionTextFn={getOptionTextFn}
                    isInsideModal={isInsideModal}
          />
        </div>
      </div>
    </Fragment>
  )
}

export default HybridList
